"use strict";
var RatingSize;
(function (RatingSize) {
    RatingSize[RatingSize["Small"] = 0] = "Small";
    RatingSize[RatingSize["Large"] = 1] = "Large";
})(RatingSize = exports.RatingSize || (exports.RatingSize = {}));

//# sourceMappingURL=Rating.Props.js.map



//////////////////
// WEBPACK FOOTER
// ../components/Rating/Rating.Props.js
// module id = 255
// module chunks = 0